import styled from "styled-components";

export const FestivalMainNewsWrapper = styled.div`
  padding-bottom: 100px;
`;

export const FestivalMainNewsHeaderWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 16px;
  > .title {
    height: 26px;
    padding: 0 16px;
  }
`;

export const FestivalMainNewsHeaderMoreButton = styled.div`
  height: 26px;
  padding: 6px 8px 6px 12px;
  color: #121212;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border-radius: 15px;
  border: 1px solid var(--Black-200, #b7b7b7);
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const FestivalMainNewsContent = styled.div`
  padding: 0 16px;
  margin-top: 20px;
`;

export const FestivalMainNewsSwiperItem = styled.div`
  width: 100%;
  height: 210px;
  border-radius: 8px;
  position: relative;

  > img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const FestivalMainNewsSwiperText = styled.div`
  color: #fff;
  position: absolute;
  bottom: 20px;
  left: 12px;
  font-weight: 700;
  font-size: 18px;
`;

export const FestivalMainNewsSearchWrapper = styled.div`
  width: 100%;
  height: 35px;
  border-radius: 15px;
  padding: 10px 12px;
  background: #f0f0f0;
  display: flex;
  gap: 5px;
  justify-content: space-between;

  > input {
    background: #f0f0f0;
    outline: none;
    border: none;
    flex: 1;
    font-weight: 600;
    font-size: 12px;
  }

  > input::placeholder {
    color: var(--Black-200, #b7b7b7);
  }
`;

export const FestivalMainNewsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  min-height: 340px;

  > .no-data {
    line-height: 340px;
    color: var(--Black-300, #808080);
    text-align: center;
    font-size: 14px;
    font-weight: 500;
  }
`;

export const FestivalMainNewsListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  height: 79px;
  width: 100%;

  > .image {
    width: 79px;
    height: 79px;
    border-radius: 8px;
    flex-shrink: 0;

    > img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }
`;

export const FestivalMainNewsListItemText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: space-between;
  height: 100%;

  > .news {
    font-weight: 600;
    font-size: 14px;
  }

  > .time {
    color: var(--Black-300, #808080);
    font-weight: 500;
    font-size: 14px;
  }
`;
